import React, { useReducer } from 'react';
import RecordReducer from './recordReducer';
import RecordContext from './recordContext';

import bg1 from '../../../images/bg1.png';
import bg2 from '../../../images/bg2.png';
import bg3 from '../../../images/bg3.png';
import bg4 from '../../../images/bg4.png';
import bg5 from '../../../images/bg5.png';
import art1 from '../../../images/art1.png';
import art2 from '../../../images/art2.png';
import art3 from '../../../images/art3.png';
import art4 from '../../../images/art4.png';
import art5 from '../../../images/art5.png';
import art6 from '../../../images/art6.png';
import art7 from '../../../images/art7.png';
import art12 from '../../../images/art12.png';
import art9 from '../../../images/art9.png';
import art10 from '../../../images/art10.png';
import art11 from '../../../images/art11.png';
import art16 from '../../../images/art16.png';

const RecordState = (props) => {
  const recordInitialState = {
    records: [
      {
        id: 1,
        src: bg1,
        heading: 'Rezonate',
        para:
          ' A blend of street culture and futuristic design  -  a distinctive style of clothing for our music community around the world',
      },
      {
        id: 2,
        src: bg2,
        heading: 'Rezonate',
        para:
          ' A blend of street culture and futuristic design  -  a distinctive style of clothing for our music community around the world',
      },
      {
        id: 3,
        src: bg3,
        heading: 'Rezonate',
        para:
          ' A blend of street culture and futuristic design  -  a distinctive style of clothing for our music community around the world',
      },
      {
        id: 4,
        src: bg4,
        heading: 'Rezonate',
        para:
          ' A blend of street culture and futuristic design  -  a distinctive style of clothing for our music community around the world',
      },
      {
        id: 5,
        src: bg5,
        heading: 'Rezonate',
        para:
          ' A blend of street culture and futuristic design  -  a distinctive style of clothing for our music community around the world',
      },
    ],
    moreRecords: [
      {
        id: 1,
        src: bg5,
        heading1: 'Rezonate',
        heading2: 'Jon casey',
      },
      {
        id: 2,
        src: bg5,
        heading1: 'Rezonate',
        heading2: 'Jon casey',
      },
      {
        id: 3,
        src: bg5,
        heading1: 'Rezonate',
        heading2: 'Jon casey',
      },
      {
        id: 4,
        src: bg5,
        heading1: 'Rezonate',
        heading2: 'Jon casey',
      },
      {
        id: 5,
        src: bg5,
        heading1: 'Rezonate',
        heading2: 'Jon casey',
      },
      {
        id: 6,
        src: bg5,
        heading1: 'Rezonate',
        heading2: 'Jon casey',
      },
      {
        id: 7,
        src: bg5,
        heading1: 'Rezonate',
        heading2: 'Jon casey',
      },
      {
        id: 8,
        src: bg5,
        heading1: 'Rezonate',
        heading2: 'Jon casey',
      },
      {
        id: 9,
        src: bg5,
        heading1: 'Rezonate',
        heading2: 'Jon casey',
      },
    ],
    artists: [
      { id: 1, src: art11 },
      { id: 2, src: art1 },
      { id: 3, src: art2 },
      { id: 4, src: art3 },
      { id: 5, src: art4 },
      { id: 6, src: art5 },
      { id: 7, src: art6 },
      { id: 12, src: art7 },
      { id: 9, src: art12 },
      { id: 10, src: art9 },
      { id: 11, src: art10 },
      { id: 16, src: art16 },
    ],
    delhi: [
      { id: 10, src: art9 },
      { id: 11, src: art10 },
      { id: 16, src: art16 },
    ],
    showCards: null,
  };

  const [state] = useReducer(RecordReducer, recordInitialState);

  return (
    <RecordContext.Provider
      value={{
        records: state.records,
        moreRecords: state.moreRecords,
        artists: state.artists,
        delhi: state.delhi,
        showCards: state.showCards,
      }}
    >
      {props.children}
    </RecordContext.Provider>
  );
};
export default RecordState;
